// Curry takes an N-arity function and returns an accumulator function
// when the accumulator is inoked with k number of arguments
// we check if k >= N, (whether the functions arity is satisfied)
// if it is, we invoke fn with the arguments, if no we create a copy of fn
// that has the first k arguments partially applied and pass it to curry
// as the next fn with its reduce arity of N - k.

export default function curry(fn) {
	return (...args) => {
		if (args.length === 0) {
			throw new Error('@insight/toolkit-utils: curry() received no arguments when invoked')
		}
		if (args.length >= fn.length) {
			return fn(...args)
		}

		return curry(fn.bind(null, ...args))
	}
}
